import React from "react";
import BasicCustomField from "../BasicCustomField";
import { Calculation } from "../../../../../../src/application/Contracts";
import MatchingTapWaterSystemModel = Calculation.MatchingTapWaterSystemModel;
import formModelStore from "../../../../../store/FormModelStore";
import ArrowsIcon from "../icons/ArrowsIcon";

export default class TwsMatchingTapWaterSystem extends BasicCustomField {
    onChangeInput = (matchingTapWaterSystemModel: MatchingTapWaterSystemModel) => {
        this.onChange(matchingTapWaterSystemModel);
    }
    renderRow = (matchingTapWaterSystemModel: MatchingTapWaterSystemModel) => {
        return <tr key={matchingTapWaterSystemModel.id}>
            <td className={`input-cell`}>
                <div className={`table-radio-button`}>
                    <input id={`matching-tap-water-system-${matchingTapWaterSystemModel.id}`} type={"radio"}
                        checked={this.checkedRow(matchingTapWaterSystemModel.id)}
                        name={`matching-tap-water-system`}
                        onChange={() => this.onChangeInput(matchingTapWaterSystemModel)} />
                    <label htmlFor={`matching-tap-water-system-${matchingTapWaterSystemModel.id}`}></label>
                </div>
            </td>
            <td>{matchingTapWaterSystemModel.artNo}<br />{matchingTapWaterSystemModel.prodFamilyDisplayName}</td>
            <td>{matchingTapWaterSystemModel.series}<br />{matchingTapWaterSystemModel.tProg}</td>
            <td>{matchingTapWaterSystemModel.p}<br />{matchingTapWaterSystemModel.inst}</td>
            <td>{matchingTapWaterSystemModel.primPump}<br />{matchingTapWaterSystemModel.secPump}</td>
            <td>{matchingTapWaterSystemModel.heType}<br />{matchingTapWaterSystemModel.np}</td>
            <td>{matchingTapWaterSystemModel.primKitArtNo ?? '-'}<br />{matchingTapWaterSystemModel.cv}
            </td>
        </tr>
    }

    checkedRow = (row: string) => {
        return formModelStore.formModel?.waterSystem?.selectedTapWaterSystemModel?.value?.id === row;
    }
    renderEmpty = () => {
        return <div className={`empty-expandable-container-results`}>{__('No matching water systems')}</div>
    }

    render() {
        if ((this.props.additionalModel as MatchingTapWaterSystemModel[]).length === 0) {
            return this.renderEmpty();
        }

        return <React.Fragment>
            <table className={`step-stripped-table data-only`}>
                <thead>
                    <tr>
                        <th></th>
                        <th>{__('Art.No')}<br />{__('Prod. Family')}</th>
                        <th>{__('Series')}<br />{__('Tprog')}</th>
                        <th>{__('P(kW)')}<br />{__('Inst?')}</th>
                        <th>{__('Prim. Pump')}<br />{__('Sec. Pump')}</th>
                        <th>{__('HE type')}<br />{__('Np')}</th>
                        <th>{__('PrimKitArtNo')}<br />{__('CV')}</th>
                    </tr>
                </thead>
                <tbody>
                    {(this.props.additionalModel as MatchingTapWaterSystemModel[]).map(matchingTapWaterSystemModel => this.renderRow(matchingTapWaterSystemModel))}
                </tbody>
            </table>
        </React.Fragment>
    }
}